import {GroupProperties} from "../styles/GroupProperties";
import {NumberProperty} from "../NumberProperty";
import {PDFControlBase} from "../../Core/PDFControlBase";
import {SwitchProperty} from "InternalShared/PageBuilder/Controls/Properties/SwitchProperty";


export class DimensionStyleSet {
    static GetStyles(item:PDFControlBase)
    {
        let dimension=[];
        if(item.behavior.IsDraggable) {
            dimension.push(new SwitchProperty(item, 'Lock', item.Options).SetLabel('Lock (locked elements can\'t be dragged)'));
            dimension.push(new NumberProperty(item, 'Top', item.Options.Styles).SetLabel('Top'));
            dimension.push(new NumberProperty(item, 'Left', item.Options.Styles).SetLabel('Left'));
        }
        if(item.AllowedResizeDirection=='horizontal'||item.AllowedResizeDirection=="both")
            dimension.push(new NumberProperty(item,'Width',item.Options.Styles).SetLabel('Width'));
        if(item.AllowedResizeDirection=="vertical"||item.AllowedResizeDirection=="both")
            dimension.push(new NumberProperty(item,'Height',item.Options.Styles).SetLabel('Height'));

        return new GroupProperties('Dimensions').AddProperties(dimension);
    }

}